import React from 'react';
import './typography.scss';
import { TypographyProps } from '../../types/typography';

// Defining the HTML tag that the component will support
const variantsMapping: { [key: string]: keyof JSX.IntrinsicElements } = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'span',
  subtitle2: 'span',
  body1: 'p',
  body2: 'p',
  button: 'span',
  caption: 'label',
  overline: 'p',
  error: 'span',
};

const Typography: React.FC<TypographyProps> = ({
  variant, color = 'dark', children, className, noMargins, ...props
}) => {
  const Component = variant ? variantsMapping[variant] : 'p';
  const classBase = 'typography';

  return (
    <Component
      className={`typography ${classBase}-variant-${variant} ${classBase}-color-${color} ${noMargins ? 'margin-0' : ''} default-font ${
        className || ''
      }`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Typography;
